import { render, staticRenderFns } from "./ModalItemDraftingKirimBalik.vue?vue&type=template&id=85211af0&"
import script from "./ModalItemDraftingKirimBalik.vue?vue&type=script&lang=js&"
export * from "./ModalItemDraftingKirimBalik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports